import React, { useEffect, useState, } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  useTheme,
  useMediaQuery,
  Badge,
  Avatar,
  Chip,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Home,
  LocalShipping,
  ShoppingBag,
  Event,
  TableRestaurant,
  QrCode,
  ShoppingCart,
  LocationOn,
  Phone,
  DarkMode,
  LightMode,
  Store,
  Person,
  Logout
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRestaurant } from '../../contexts/RestaurantContext';
import { useCustomTheme } from '../../contexts/ThemeContext';
import { getImageProps } from '../../utils/imageUtils';
import OutletSelectionModal from './OutletSelectionModal';
import CartDrawer from './CartDrawer';
import LoginModal from './LoginModal';
import { themeColorConfig } from '../Themes/themeColorConfig';

// import colors from '../colors';

const navColor = {
  bg: '#351113',
  text: '#FFCF03',
  white: '#FFFFF0',
  hover: '#35111380'

}

let colorConfig = new themeColorConfig()

const UserNavbar = () => {
  // const storage = JSON.parse(sessionStorage.getItem('selectedOutletId'))
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [locationMenuOpen, setLocationMenuOpen] = useState(false);
  const [locationAnchor, setLocationAnchor] = useState(null);
  const [cartOpen, setCartOpen] = useState(false);
  const [outletSelection, setOutletSelection] = useState({});
  const [showImage, setShowImage] = useState(true);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [loginMenuOpen, setLoginMenuOpen] = useState(false);
  const [actualServiceType, setActualServiceType] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { loginUser } = useRestaurant()

  // console.log("Session Storage => ", JSON.parse(sessionStorage.getItem('selectedOutletId')));

  // console.log("Outlet Selection => " , storage);

  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));




  const {
    restaurant,
    selectedOutlet,
    getCartItemCount,
    outlets,
    selectOutlet,
    isDeliveryAvailable,
    isTakeawayAvailable,
    isDineInAvailable,
    showOutletSelectionModal,
    handleOutletSelection,
    showOutletSelection,
    closeOutletSelection,
    loadRestaurantData
  } = useRestaurant();

  useEffect(() => {
    loadRestaurantData()
  }, [])

  useEffect(() => { console.log('anchorEl changed:', anchorEl); }, [anchorEl])

  const { isDarkMode, toggleTheme } = useCustomTheme();

  const cartItemCount = getCartItemCount ? getCartItemCount() : 0;

  const navigationItems = [
    { label: 'Home', path: '/', icon: <Home /> },
    { label: 'Order Online', path: '/delivery', icon: <LocalShipping /> },
    // { label: 'Takeaway', path: '/takeaway', icon: <ShoppingBag /> },
    { label: 'Catering', path: '/catering', icon: <Event /> },
    { label: 'Reservations', path: '/table-reservations', icon: <TableRestaurant /> },
  ];

  console.log("Themes => ", colorConfig.navBarColor);
  console.log("Themes => ", colorConfig.navBarTextColor);
  console.log("Outlet Selected => ", selectedOutlet);
  const handleNavigation = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  const handleLocationMenuOpen = (event) => {
    setLocationAnchor(event.currentTarget);
    setLocationMenuOpen(true);
  };

  const handleLocationMenuClose = () => {
    setLocationAnchor(null);
    setLocationMenuOpen(false);
  };

  const handleOutletSelect = (outlet) => {
    selectOutlet(outlet);
    handleLocationMenuClose();
  };

  const isActivePath = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  // Get service availability for an outlet
  const getOutletServices = (outlet) => {
    const services = [];
    if (outlet.is_delivery_available) services.push('Delivery');
    if (outlet.is_takeaway_available) services.push('Takeaway');
    if (outlet.is_dine_in_available) services.push('Dine-in');
    return services;
  };


  const handleLoginModalOpen = (e) => {
    if (loginUser?.username) {
      setAnchorEl(e.currentTarget);
    }
    else {
      setLoginModalOpen(true);
    }

  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setShowImage(true);  // show when at top
      } else {
        setShowImage(false); // hide when scrolling down
      }
    };



    window.addEventListener("scroll", handleScroll);

    // cleanup listener when component unmounts
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          top: 0,
          marginTop: '0px !important',
          borderRadius: 0,
          bgcolor: colorConfig.navBarColor,
          color: "text.primary",
          // borderBottom: '1px solid',
          // borderColor: 'divider',
          maxHeight: '72px',
          overflow: 'hidden',
          backdropFilter: 'blur(10px)',
          background: (theme) =>

            theme.palette.mode === 'dark'
              ? 'rgba(30, 41, 59, 0.95)'
              : colorConfig.navBarColor,

        }}
      >
        <Toolbar sx={{
          minHeight: { xs: 56, sm: 64, md: 72 },
          px: { xs: 1, sm: 2, md: 3 },
          gap: { xs: 0.5, sm: 1, md: 2 }
        }}>

          {/* ---------------  Mobile Menu Button ------------------- */}
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => setMobileMenuOpen(true)}
            sx={{
              display: { xs: 'flex', md: 'none' },
              p: { xs: 1, sm: 1.5 },
              borderRadius: 1,
              bgcolor: 'transparent',
              '&:hover': {
                bgcolor: 'action.hover',
              },
              '& .MuiSvgIcon-root': { fontSize: { xs: '24px', sm: '28px' } }
            }}
          >
            <MenuIcon />
          </IconButton>

          {/* Logo */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: 0.5, sm: 1 },
              cursor: 'pointer',
              flexShrink: 0,
              mr: { xs: 0.5, sm: 1, md: 2 }
            }}
            onClick={() => navigate('/')}
          >
            {restaurant?.logo_url ? (
              <Box
                component="img"
                src={getImageProps(restaurant.logo_url).src}
                alt={restaurant?.name || 'Restaurant'}
                sx={{
                  width: { xs: 40, sm: 50, md: 60 },
                  height: { xs: 40, sm: 50, md: 60 },
                  borderRadius: 1,
                  border: 'none',
                  boxShadow: 1,
                  objectFit: 'cover'
                }}
              />
            ) : (
              <Box
                sx={{
                  width: { xs: 40, sm: 50, md: 60 },
                  height: { xs: 40, sm: 50, md: 60 },
                  borderRadius: 1,
                  border: 'none',
                  bgcolor: 'primary.main',
                  // bgcolor:'red',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' }
                }}
              >
                {restaurant?.name?.charAt(0) || 'R'}
              </Box>
            )}

            {/* <Typography
              // variant="h6"
              sx={{
                display: { xs: 'block', sm: 'block' },
                fontWeight: 'bold',
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem !important' },
                // background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                background:'#800000',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                maxWidth: { xs: '120px', sm: '200px', md: 'none' },
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {restaurant?.name || 'Restaurant'}
            </Typography> */}
          </Box>

          {/* Desktop Navigation */}
          <Box sx={{
            display: { xs: 'none', md: 'flex' },
            gap: 0.5,
            flexGrow: 1,
            justifyContent: 'center'
          }}>
            {navigationItems.map((item) => (
              <Button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                startIcon={item.icon}
                sx={{
                  color: isActivePath(item.path) ? 'primary.main' : 'text.primary',
                  bgcolor: isActivePath(item.path) ? 'primary.50' : 'transparent',
                  borderRadius: 1,
                  textTransform: 'none',
                  fontWeight: isActivePath(item.path) ? 600 : 400,
                  fontSize: { xs: '0.875rem', sm: '1rem', md: '1.125rem' },
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 1, sm: 1.25, md: 1.5 },
                  minHeight: { xs: '40px', sm: '44px', md: '48px' },
                  '&:hover': {
                    bgcolor: isActivePath(item.path) ? 'primary.100' : 'action.hover',
                  },
                  '& .MuiSvgIcon-root': { fontSize: { xs: '18px', sm: '20px', md: '22px' } }
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          {/* Right Side Actions */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 0.25, sm: 0.5, md: 1 },
            ml: 'auto'
          }}>
            {/* Outlet Selector */}
            <Button
              variant="outlined"
              startIcon={<Store />}
              onClick={showOutletSelection}
              sx={{
                display: { xs: 'none', sm: 'flex' },
                borderRadius: 1,
                textTransform: 'none',
                minWidth: 'auto',
                px: { xs: 1, sm: 1.5, md: 2 },
                py: { xs: 0.75, sm: 1, md: 1.25 },
                fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
                borderColor: selectedOutlet ? 'success.main' : 'divider',
                color: selectedOutlet ? 'success.main' : 'text.primary',
                '&:hover': {
                  borderColor: selectedOutlet ? 'success.dark' : 'primary.main',
                  bgcolor: selectedOutlet ? 'success.50' : 'transparent',
                },
                '& .MuiSvgIcon-root': { fontSize: { xs: '16px', sm: '18px', md: '20px' } }
              }}
            >
              <Box sx={{
                maxWidth: { xs: '60px', sm: '80px', md: '120px' },
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>
                {selectedOutlet?.name || 'Select Outlet'}
              </Box>
            </Button>

            <Button sx={{
              borderRadius: 50,
            }}
              onClick={(e) => handleLoginModalOpen(e)}
            >
              {loginUser?.username ? loginUser.username : "Login"}
            </Button>

            {/*  ----------- Profile Menu --------------- */}
            <Menu

              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)}
              slotProps={{
                list: {
                  'aria-labelledby': 'basic-button',
                },
              }}
            >
              <MenuItem onClick={() => navigate('/profile')}><Person style={{ marginRight: 8 }} /> Profile</MenuItem>
              <MenuItem onClick={() => {
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                sessionStorage.removeItem('user');
                setAnchorEl(null);
                navigate('/homepage')
                window.location.reload();

              }}><Logout style={{ marginRight: 8 }} /> Logout</MenuItem>
            </Menu>



            {/* Theme Toggle */}
            <IconButton
              onClick={toggleTheme}
              color="inherit"
              sx={{
                p: { xs: 0.75, sm: 1, md: 1.25 },
                borderRadius: 1,
                bgcolor: 'transparent',
                '&:hover': {
                  bgcolor: 'action.hover',
                },
                '& .MuiSvgIcon-root': { fontSize: { xs: '18px', sm: '20px', md: '22px' } }
              }}
            >
              {isDarkMode ? <LightMode /> : <DarkMode />}
            </IconButton>

            {/* Contact */}
            <IconButton
              href={`tel:${restaurant?.phone}`}
              color="inherit"
              sx={{
                display: { xs: 'none', md: 'flex' },
                p: { xs: 0.75, sm: 1, md: 1.25 },
                borderRadius: 1,
                bgcolor: 'transparent',
                '&:hover': {
                  bgcolor: 'action.hover',
                },
                '& .MuiSvgIcon-root': { fontSize: { xs: '18px', sm: '20px', md: '22px' } }
              }}
            >
              <Phone />
            </IconButton>

            {/* Cart */}
            <IconButton
              onClick={() => setCartOpen(true)}
              color="primary"
              sx={{
                p: { xs: 0.75, sm: 1, md: 1.25 },
                borderRadius: 1,
                bgcolor: 'transparent',
                border: '1px solid',
                borderColor: 'primary.main',
                '&:hover': {
                  bgcolor: 'primary.50',
                  borderColor: 'primary.dark',
                },
                '& .MuiSvgIcon-root': { fontSize: { xs: '18px', sm: '20px', md: '22px' } }
              }}
            >
              <Badge
                badgeContent={cartItemCount}
                color="error"
                sx={{
                  '& .MuiBadge-badge': {
                    fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
                    minWidth: { xs: '14px', sm: '16px', md: '18px' },
                    height: { xs: '14px', sm: '16px', md: '18px' },
                  }
                }}
              >
                <ShoppingCart />
              </Badge>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        PaperProps={{
          sx: {
            width: { xs: '75vw', sm: 280 },
            maxWidth: '280px'
          }
        }}
      >
        <Box sx={{ p: 1.5, textAlign: 'center', }}>
          <Box
            component="img"
            src={restaurant?.logo_url}
            sx={{
              width: 50,
              height: 50,
              mx: 'auto',
              mb: 0.75,
              borderRadius: '50%',
              border: 'none',
              bgcolor: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.25rem'
            }}
          >
            {restaurant?.name?.charAt(0) || 'R'}
          </Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom sx={{
            fontSize: '1rem',
            lineHeight: 1.2,
            mb: 0.5
          }}>
            {restaurant?.name || 'Restaurant'}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{
            mb: 1.5,
            fontSize: '0.75rem',
            lineHeight: 1.2
          }}>
            {restaurant?.tagline || 'Delicious food, great service'}
          </Typography>
        </Box>

        <Divider />

        <List sx={{ px: 0.5, py: 0.5 }}>
          {navigationItems.map((item) => (
            <ListItem key={item.path} disablePadding>
              <ListItemButton
                onClick={() => handleNavigation(item.path)}
                sx={{
                  borderRadius: 1,
                  mb: 0.25,
                  py: 1.25,
                  px: 1,
                  bgcolor: isActivePath(item.path) ? 'primary.50' : 'transparent',
                  color: isActivePath(item.path) ? 'inherit' : 'text.primary',
                  minWidth: 50,
                  minHeight: '48px',
                  '& .MuiListItemIcon-root': { fontSize: '20px' }
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isActivePath(item.path) ? 'inherit' : 'text.primary',
                    minWidth: 50,
                    '& .MuiSvgIcon-root': { fontSize: '20px' }
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  sx={{
                    '& .MuiListItemText-primary': {
                      fontSize: '0.875rem',
                      fontWeight: isActivePath(item.path) ? 600 : 400
                    }
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Divider sx={{ mt: 0.5 }} />

        <Box sx={{ p: 1 }}>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<LocationOn sx={{ fontSize: '1rem' }} />}
            onClick={showOutletSelection}
            sx={{
              mb: 1,
              py: 1,
              fontSize: '0.8rem',
              textTransform: 'none',
              borderRadius: 1,
              borderColor: selectedOutlet ? 'success.main' : 'divider',
              color: selectedOutlet ? 'success.main' : 'text.primary',
              '&:hover': {
                borderColor: selectedOutlet ? 'success.dark' : 'primary.main',
                bgcolor: selectedOutlet ? 'success.50' : 'transparent',
              }
            }}
          >
            <Box sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '160px'
            }}>
              {selectedOutlet?.name || 'Select Outlet'}
            </Box>
          </Button>

          <Button
            fullWidth
            variant="outlined"
            startIcon={<Phone sx={{ fontSize: '1rem' }} />}
            href={`tel:${restaurant?.phone}`}
            sx={{
              py: 1,
              fontSize: '0.8rem',
              textTransform: 'none',
              borderRadius: 1
            }}
          >
            Call Us
          </Button>
        </Box>
      </Drawer>

      {/* Location Menu */}
      <Menu
        anchorEl={locationAnchor}
        open={locationMenuOpen}
        onClose={handleLocationMenuClose}
        PaperProps={{
          sx: { minWidth: 300, borderRadius: 1, mt: 1, maxHeight: '70vh' }
        }}
      >
        <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
            Select Your Outlet
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Choose an outlet to see available menu items and services
          </Typography>
        </Box>

        {(outlets || []).map((outlet) => {
          const services = getOutletServices(outlet);
          const isSelected = selectedOutlet?.id === outlet?.id;

          return (
            <MenuItem
              key={outlet?.id}
              onClick={() => handleOutletSelect(outlet)}
              selected={isSelected}
              sx={{
                py: 2,
                px: 2,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '&:last-child': { borderBottom: 'none' },
                '&:hover': {
                  bgcolor: 'action.hover',
                },
                '&.Mui-selected': {
                  bgcolor: 'primary.50',
                  '&:hover': {
                    bgcolor: 'primary.100',
                  }
                }
              }}
            >
              <Box sx={{ width: '100%' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                  <Typography variant="body1" fontWeight="600">
                    {outlet?.name}
                  </Typography>
                  {isSelected && (
                    <Chip
                      label="Selected"
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ fontSize: '0.9rem' }}
                    />
                  )}
                </Box>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                  {outlet?.address}
                </Typography>

                {services.length > 0 && (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {services.map((service) => (
                      <Chip
                        key={service}
                        label={service}
                        size="small"
                        variant="outlined"
                        color="success"
                        sx={{
                          fontSize: '0.65rem',
                          height: 20,
                          '& .MuiChip-label': { px: 1 }
                        }}
                      />
                    ))}
                  </Box>
                )}

                {services.length === 0 && (
                  <Typography variant="caption" color="warning.main">
                    No services available
                  </Typography>
                )}
              </Box>
            </MenuItem>
          );
        })}

        {(outlets || []).length === 0 && (
          <MenuItem disabled sx={{ py: 2, px: 2 }}>
            <Box sx={{ textAlign: 'center', width: '100%' }}>
              <Typography variant="body2" color="text.secondary">
                No outlets available
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Please check back later
              </Typography>
            </Box>
          </MenuItem>
        )}
      </Menu>

      {/* Outlet Selection Modal */}
      <OutletSelectionModal
        open={showOutletSelectionModal}
        onClose={closeOutletSelection}
        onOutletSelect={handleOutletSelection}
      />

      {/* ----- Login Modal ----- */}
      <LoginModal
        loginModalOpen={loginModalOpen}
        setLoginModalOpen={setLoginModalOpen}

      />

      {/* Cart Drawer */}
      <CartDrawer
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        onCheckout={(serviceType, value) => {
          if (serviceType === 'guest-signup') {
            let typeToUse = value || actualServiceType;
            console.log("Yes Here the Service Type is :", typeToUse);
            navigate('/guest-signup', { state: { serviceType: typeToUse } });
          }
        }}

        actualServiceType={actualServiceType}
        setActualServiceType={setActualServiceType}
      />
    </>
  );
};

export default UserNavbar;
